/* global axios */
import ApiClient from './ApiClient';

class DigitalHumansAPI extends ApiClient {
  constructor() {
    super('digital_humans', { accountScoped: true });
  }

  updateWithInboxes(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  createWithInboxes(data) {
    return axios.post(this.url, data);
  }

  testIntegration(id, { api_key, base_url }) {
    return axios.post(`${this.url}/${id}/test_integration`, {
      api_key,
      base_url,
    });
  }

  architecture(id) {
    return axios.get(`${this.url}/${id}/architecture`);
  }

  architectureSource(id, path) {
    return axios.get(`${this.url}/${id}/architecture_source`, {
      params: { path },
    });
  }

  // ── Editor de Fluxo (Máquina de Fluxos) ──
  flowMap(id) {
    return axios.get(`${this.url}/${id}/flow_map`);
  }

  saveFlowMap(id, flowMap) {
    return axios.post(`${this.url}/${id}/save_flow_map`, { flow_map: flowMap });
  }

  testFlow(id, { flowMap, messages }) {
    return axios.post(`${this.url}/${id}/test_flow`, {
      flow_map: flowMap,
      messages,
    });
  }

  getFicha(id) {
    return axios.get(`${this.url}/${id}/ficha`);
  }

  saveFicha(id, ficha) {
    return axios.put(`${this.url}/${id}/save_ficha`, { ficha });
  }
}

export default new DigitalHumansAPI();
